import { render, staticRenderFns } from "./materMove.vue?vue&type=template&id=24ad1752&"
import script from "./materMove.vue?vue&type=script&lang=js&"
export * from "./materMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports